module.exports = __webpack_public_path__ + "img/instagram.6c9a5c8f.svg";